import IntegrationCallListResourcePagingResultModel from '../../generated/types/model/resource/IntegrationCallListResourcePagingResultModel';

export default class IntegrationCallListResourcePagingResultViewModel extends IntegrationCallListResourcePagingResultModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
